const getters = {
  allStoreCategorys: (state) => state.common.allStoreCategorys,
};
export default getters;
